<vdms-hq-ui-dialog-wrapper [sharedE2eId]="'status-columns-dialog-wrapper'" footerAlign="space-between">
  <ng-container title>
    <h1>
      {{ 'launchpad.delivery.mandatory_fields.title' | translate }}
    </h1>
  </ng-container>
  <ng-container content>
    <div class="content-wrapper">
      <div>
        <h1>
          {{ 'launchpad.delivery.mandatory_fields.subtitle' | translate }}
        </h1>
        <span>{{ 'launchpad.delivery.mandatory_fields.description' | translate }}</span>
      </div>
      <img src="assets/common/help/mandatory-fields-info.svg" alt="Mandatory Fields Info" class="content-image" />
    </div>
  </ng-container>
  <ng-container footer>
    <vdms-hq-ui-button [sharedE2eId]="'mandatory-fields-dismiss-button'" color="secondary" (click)="close(true)">
      @if (data.manualTrigger) {
        <span>Close</span>
      } @else {
        <span>Don't show again</span>
      }
    </vdms-hq-ui-button>
    <vdms-hq-ui-button [sharedE2eId]="'enable-status-columns-button'" color="primary" (click)="close(false)"
      >Enable status columns</vdms-hq-ui-button
    >
  </ng-container>
</vdms-hq-ui-dialog-wrapper>
